import { render, staticRenderFns } from "./FormValidationPlaceholder.vue?vue&type=template&id=384d1e59"
import script from "./FormValidationPlaceholder.vue?vue&type=script&lang=js"
export * from "./FormValidationPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports